/* Landing-page motion: scroll reveals, count-up numbers, rotating headline words, parallax. */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('js-motion');

  const reveal = (el) => el.classList.add('is-in');
  const countUp = (el) => {
    const match = el.textContent.trim().match(/^(\D*)(\d+)(.*)$/);
    if (!match || reduce) return;
    const [, before, digits, after] = match;
    const target = Number(digits);
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / 1400);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = `${before}${Math.round(target * eased)}${after}`;
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const targets = document.querySelectorAll('[data-reveal], [data-count]');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(reveal);
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          if (entry.target.hasAttribute('data-count')) countUp(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach((el) => io.observe(el));
  }

  // Rotating words: the first word shows without JS; the rest take turns.
  document.querySelectorAll('[data-rotate]').forEach((wrap) => {
    const words = [...wrap.children];
    if (words.length < 2) return;
    let index = 0;
    words[0].classList.add('is-active');
    if (reduce) return;
    setInterval(() => {
      words[index].classList.remove('is-active');
      index = (index + 1) % words.length;
      words[index].classList.add('is-active');
    }, Number(wrap.dataset.rotate) || 2600);
  });

  // Parallax: [data-parallax="0.2"] drifts against the scroll by that factor.
  const layers = [...document.querySelectorAll('[data-parallax]')];
  if (!reduce && layers.length) {
    let ticking = false;
    const update = () => {
      ticking = false;
      layers.forEach((el) => {
        const rect = el.parentElement.getBoundingClientRect();
        const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * Number(el.dataset.parallax);
        el.style.translate = `0 ${offset.toFixed(1)}px`;
      });
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }
})();
